webpackJsonp([89056747556744],{

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _page = __webpack_require__(5);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _contentblock = __webpack_require__(9);
	
	var _contentblock2 = _interopRequireDefault(_contentblock);
	
	var _abblock = __webpack_require__(53);
	
	var _abblock2 = _interopRequireDefault(_abblock);
	
	var _senograph = __webpack_require__(50);
	
	var _senograph2 = _interopRequireDefault(_senograph);
	
	var _senograph2x = __webpack_require__(51);
	
	var _senograph2x2 = _interopRequireDefault(_senograph2x);
	
	__webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DevicesPage = function DevicesPage(props) {
	  return _react2.default.createElement(
	    'main',
	    null,
	    _react2.default.createElement(
	      'a',
	      { href: 'http://www.frueh-erkennen.at/' },
	      _react2.default.createElement(_page2.default, { headline: 'Brustkrebs\xADfr\xFCherkennung' })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'container-custom' },
	      _react2.default.createElement(
	        _abblock2.default,
	        { right: true, img: _senograph2.default, img2x: _senograph2.default },
	        _react2.default.createElement(
	          _contentblock2.default,
	          { title: 'Brustkrebs-Fr\xFCherkennung \u2013 wichtig\xA0und\xA0gut' },
	          _react2.default.createElement(
	            'p',
	            null,
	            'Um \xF6sterreichweit eine fl\xE4chendeckende Versorgung f\xFCr die Brustkrebs-Fr\xFCherkennung anbieten zu k\xF6nnen, gibt es das \u201E\xD6sterreichische Brustkrebs-Fr\xFCherkennungsprogramm\u201C (BFKP). Wir, das Radiologiezentrum Bregenz, sind Teil dieses wichtigen Netzwerkes. Damit das Programm auch immer auf neuestem Wissensstand durchgef\xFChrt wird, m\xFCssen wir strenge Qualit\xE4tsvorgaben erf\xFCllen:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            { className: 'feature-list' },
	            _react2.default.createElement(
	              'li',
	              null,
	              'Unsere Mitarbeiterinnen und Mitarbeiter werden laufend geschult.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Wir sind mit dem Zertifikat Mammadiagnostik der \xD6sterreichischen \xC4rztekammer ausgezeichnet.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              'Wir verwenden nur moderne, digitale Ger\xE4te, die laufend technisch \xFCberpr\xFCft werden. Die Mammografie-Bilder werden nach dem 4-Augen-Prinzip immer von zwei Radiologinnen bzw. Radiologen ausgewertet.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Nur wenn wir all diese Qualit\xE4tskriterien erf\xFCllen, d\xFCrfen wir Mammografien im Rahmen des \xD6sterreichischen Brustkrebs-Fr\xFCherkennungsprogramms durchf\xFChren. Dies gilt auch f\xFCr Mammografien bei Krankheitsverdacht.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Ausf\xFChrliche Informationen zum Brustkrebs-Fr\xFCherkennungsprogramm erhalten sie auf der Internetseite: ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://frueh-erkennen.at' },
	              'www.frueh-erkennen.at'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { 'class': 'banner' },
	      _react2.default.createElement(
	        'div',
	        { 'class': 'banner-wrapper' },
	        _react2.default.createElement(
	          'h1',
	          { 'class': 'banner-headline massive featured' },
	          'Digitale Radiologie kann Leben retten.'
	        ),
	        _react2.default.createElement(
	          'a',
	          { 'class': 'banner-link button', href: '/contact' },
	          'Vorsorgetermin vereinbaren'
	        )
	      )
	    )
	  );
	};
	
	exports.default = DevicesPage;
	module.exports = exports['default'];

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/senograph.7a269417.jpg";

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/senograph@2x.381363bd.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-bkfp-js-6353aa2ff49912ee3749.js